const config = {
  API_BASE_URL: "/api",
  ORIGIN: ["localhost", "0.0.0.0", "127.0.0.1"].indexOf(window.location.hostname) === -1 ?
    `https://${window.location.hostname.split(".")[0]}.alertrulesdev.tk`
    :
    `https://${process.env.REACT_APP_API_SUBDOMAIN}.alertrulesdev.tk`,
  STRIPE_API_KEY: "pk_test_51Ht9RUEaUrzegpW3Pn1huv6WZzw7UhqUpg0owWq4kEe5RId7s5CrBWaqLZlJ5FN6DkkBpDjvtdCHk4yG1dX68gcv00VKAbNxX9"
};

export default config;